import React from 'react';
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";

import './RettificaFatturazioneCase.css';

const RettificaFatturazioneCase = () => {
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  return (
    <div
      className="RettificaFatturazioneCase"
      data-testid="RettificaFatturazioneCase"
    >
      <CaseGenerator
        type={CaseForms.RettificaFatturazione}
        initialValues={
          {...profile,
           ...((profile.role === UserRoleEnum.PRIVATE || profile.businessName==='') && { businessName: `${profile.name} ${profile.surname}` }),
          }
         }
      />
    </div>
  );
};

export default RettificaFatturazioneCase;
